import { useNavigate } from 'react-router-dom';

export default function useNavigateToSearch() {
    const navigate = useNavigate();

    const navigateToSearch = () => {
        navigate('/search');
    };

    return navigateToSearch;
}
